class FetchSubjectTypeDefinition {
	constructor(
		public readonly accountId: number,
		public readonly subjectTypeId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchSubjectTypeDefinition;
